// extracted by mini-css-extract-plugin
export default {"ticketEdge":"ticket_ticketEdge__IoDrA"};